import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import aboutImage from '../images/about.png';

import '../css/section.css';
import Footer from '../components/Footer';

const About = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const fadeInUp = {
        hidden: { opacity: 0, y: -40 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
    };

    const slideInLeft = {
        hidden: { opacity: 0, x: -50 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: 'easeOut' } },
    };

    const slideInRight = {
        hidden: { opacity: 0, x: 50 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: 'easeOut' } },
    };

    return (


        <>

            <div className='headings'>
                <h3>About Us</h3>
            </div>

            <section className="py-5 aboutsection white-text-section" id="about" aria-labelledby="about-heading">
                <div className="container">
                    {/* Section Header */}
                    <motion.div
                        className="text-center mb-5"
                        initial="hidden"
                        whileInView="visible"
                        variants={fadeInUp}
                        viewport={{ once: true, amount: 0.3 }}
                    >
                        <h2 id="about-heading" className="display-7 fw-bold mb-3">
                            HOTEL CELEBRATIONS ROOM BANQUETS IN LUCKNOW
                        </h2>

                    </motion.div>

                    {/* Content Row */}
                    <div className="row g-4 align-items-center">
                        {/* Image */}
                        <motion.div
                            className="col-md-6"
                            initial="hidden"
                            whileInView="visible"
                            variants={slideInLeft}
                            viewport={{ once: true, amount: 0.2 }}
                        >
                            <img
                                src={aboutImage}
                                alt="Interior design showcase"
                                className="img-fluid rounded shadow"
                            />
                        </motion.div>

                        {/* Text Content */}
                        <motion.div
                            className="col-md-6"
                            initial="hidden"
                            whileInView="visible"
                            variants={slideInRight}
                            viewport={{ once: true, amount: 0.2 }}
                        >
                            <h3 className="h4 fw-semibold mb-3">ABOUT HOTEL CELEBRATIONS </h3>
                            <p className="mb-4">
                                Hotel Celebrations Rooms and Banquets Lucknow is a popular event venue that provides stylish and chic banquets for hosting a range of events. Perfect for close-knit gatherings, the rooftop can host up to 250 guests, while Hall 1 & Hall 2 can accommodate up to 250 and 150 guests here, respectively. With warm-welcoming interiors and plush seating arrangements, the venue ensures that guests can enjoy the event in style.
                            </p>

                            <h3 className="h4 fw-semibold mb-3">Why Choose US</h3>
                            <p className="mb-4">
                                At Hotel Celebrations Rooms and Banquets we understand the importance of every detail. From the grandeur of our hall to the personalized service we provide, our goal is to make your event extraordinary and memorable. Trust us to handle your special occasion with the utmost care and expertise.
                            </p>

                           
                        </motion.div>
                    </div>
                </div>
            </section>
            <Footer />

        </>
    );
};

export default About;